export const API_BASE_URL = "https://prisma-backend-service-knusxffuaq-as.a.run.app/api";
